function isFunction(value) {
    return typeof value === "function";
}
export async function resolve(resolvableValue) {
    /**
     * This doesn't work if we use `typeof resolvableValue === Function` so
     * we need to add the `isFunction` method. See this TypeScript issue
     * below for more information.
     *
     * https://github.com/microsoft/TypeScript/issues/37663#issuecomment-1081610403
     */
    const promisableValue = isFunction(resolvableValue)
        ? resolvableValue()
        : resolvableValue;
    const value = await promisableValue;
    return value;
}
